// Web shim for react-native-linear-gradient
import React from 'react';
import { View, ViewStyle, StyleSheet } from 'react-native';

interface LinearGradientProps {
  colors: string[];
  start?: { x: number; y: number };
  end?: { x: number; y: number };
  locations?: number[];
  style?: ViewStyle | ViewStyle[];
  children?: React.ReactNode;
}

// Web版本的LinearGradient
export default function LinearGradient(props: LinearGradientProps) {
  const { colors, start = { x: 0, y: 0 }, end = { x: 0, y: 1 }, style, children } = props;

  // 扁平化样式
  const flattenedStyle = StyleSheet.flatten(style) || {};

  // 如果只有一个颜色，或两个颜色相同，使用纯色背景
  if (colors.length === 1 || (colors.length === 2 && colors[0] === colors[1])) {
    return (
      <View style={[style, { backgroundColor: colors[0] }]}>
        {children}
      </View>
    );
  }

  // 计算渐变方向
  // start: {x: 0, y: 0} end: {x: 1, y: 0} = 从左到右 (90deg)
  // start: {x: 0, y: 0} end: {x: 0, y: 1} = 从上到下 (180deg)
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const angle = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
  
  // 构建CSS渐变
  const gradient = `linear-gradient(${angle}deg, ${colors.join(', ')})`;

  // 创建一个容器样式，应用渐变
  const containerStyle: any = {
    ...flattenedStyle,
    backgroundImage: gradient,
    // 确保 overflow 正确处理 borderRadius
    overflow: 'hidden',
  };

  // 移除 backgroundColor（如果有），避免覆盖渐变
  delete containerStyle.backgroundColor;

  return (
    <View style={containerStyle}>
      {children}
    </View>
  );
}
